import { useNavigate } from "react-router-dom";
import GoogleLoginButton from "./google-login-button";
import { v4 } from "uuid";

export const SignUpPopup = ({ isOpen, closeModal }: { isOpen: boolean, closeModal: () => void }) => {
    const navigate = useNavigate();
    return (
        <>
            {isOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 relative">
                        {/* Close button */}
                        <button
                            className="absolute top-3 right-3 text-gray-500"
                            onClick={closeModal}
                        >
                            &times;
                        </button>

                        {/* Modal Content */}
                        <h2 className="text-xl font-semibold mb-4 justify-center content-center text-center">Login/Sign Up</h2>
                        {/* Login Button */}
                        <div className="flex justify-around">
                            <GoogleLoginButton label='Sign up with Google' additionalStyles={{
                            }} onClick={(e: any) => {
                                e.preventDefault();
                                fetch(`${process.env.REACT_APP_API_URL}/v1/users/google`, {
                                    method: "POST",
                                    headers: {
                                        'X-Request-ID': v4(),
                                        "Content-Type": "application/json",
                                    },
                                })
                                    .then((res) => res.json())
                                    .then((res) => {
                                        window.location.href = res.url;
                                    });
                            }} />
                            {/* Signup Button */}
                            <button
                                onClick={() => navigate('/signup')}
                                className="px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition duration-300"
                            >
                                Sign Up
                            </button>
                        </div>
                        {/* login in small text below center */}
                        <p className="text-sm text-gray-500 mt-4 text-center">
                            Already have an account?{" "}
                            <button
                                onClick={() => {
                                    closeModal();
                                    navigate('/login');
                                }}
                                className="text-blue-500 hover:underline"
                            >
                                Login
                            </button>
                        </p>
                    </div>
                </div>
            )}
        </>
    )
}